/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_TEACHERS(state, users) {
    state.teachers = users
  },
  SET_TEACHERS_COUNT(state, count) {
    state.teachersCount = count
  },

  SET_STUDENTS(state, users) {
    state.students = users
  },
  SET_STUDENTS_COUNT(state, count) {
    state.studentsCount = count
  },
  SET_STUDENTS_REGISTATION_X(state, data) {
    state.studentsRegistationX = data
  },
  SET_STUDENTS_REGISTATION_Y(state, data) {
    state.studentsRegistationY = data
  },
  REMOVE_STUDENT(state, userId) {
      const ItemIndex = state.students.findIndex((p) => p.id == userId)
      state.students.splice(ItemIndex, 1)
      state.studentsCount = state.students.count
  },
  REMOVE_TEACHER(state, userId) {
      const ItemIndex = state.teachers.findIndex((p) => p.id == userId)
      state.teachers.splice(ItemIndex, 1)
      state.teachersCount = state.teachers.count
  },
}
